// Project Sentinel - role helpers (SEN-230 multi-tenancy).
//
// Two admin roles, mirroring backend/app/core/authz.py:
// - `admin`          a customer admin: full power inside its own customer only.
// - `platform_admin` the Sentinel operator: everything an admin can do, plus the
//                    platform-wide surfaces (system settings, energy prices,
//                    heartbeat skills, role permissions) and every customer.
// Check roles through these helpers, never with `role === 'admin'`. Only NAVIGATION gating lives here: who
// sees what, which roles may be assigned and what a role holds are the server's (role records, the identity
// verbs and their gate — SEN-438); the client copies of those rules are retired.

export const ADMIN_ROLE = 'admin'
export const PLATFORM_ADMIN_ROLE = 'platform_admin'

/** True for a customer admin or a platform admin. */
export function isAdminRole(role: string | null | undefined): boolean {
  return role === ADMIN_ROLE || role === PLATFORM_ADMIN_ROLE
}

/** True only for the platform admin (the Sentinel operator). */
export function isPlatformAdminRole(role: string | null | undefined): boolean {
  return role === PLATFORM_ADMIN_ROLE
}

/** Role ranks (= roles.hierarchy_level), mirroring ROLE_LEVELS in backend/app/core/authz.py (SEN-261). */
export const ROLE_LEVELS = {
  viewer: 10,
  installer: 20,
  store_manager: 30,
  coo: 40,
  area_manager: 50,
  facility_manager: 60,
  executive: 80,
  admin: 100,
  platform_admin: 110,
} as const

export type RoleCode = keyof typeof ROLE_LEVELS

/** True when a user of this hierarchy level ranks at or above `minRole`. */
export function meetsMinRole(hierarchyLevel: number | null | undefined, minRole: RoleCode): boolean {
  return (hierarchyLevel ?? 0) >= ROLE_LEVELS[minRole]
}
